/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'PORTABLE_LADDERS_HAVE_BEEN_INSPECTED_FOR_DAMAGE_AND_MAINTENANCE',
              'LADDERS_HAVE_LOCKING_DEVICES_SO_THAT_THEY_ARE_SECURE_WHEN_OPEN_',
              'WORKERS_ARE_TRAINED_TO_PLACE_LADDERS_ON_A_SECURE_EVEN_SURFACE_W',
              'THE_FACILITY_PROHIBITS_TYING_OR_FASTENING_TOGETHER_LADDERS_TO_A',
              'THE_FACILITY_PROHIBITS_PLACING_LADDERS_IN_FRONT_OF_ANY_DOORS_TH',
              'THE_FACILITY_PROHIBITS_USING_LADDERS_IN_THE_HORIZONTAL_POSITION',
              'LADDERS_ARE_SECURED_WHEN_NOT_IN_USE',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_16: valueSchema,
  },
}
